const manualOrders = {
    cash: 'Efectivo',
    "credit-card": "Tarjeta",
    "wristband-rfid": "Pulsera",
    addToCart: 'Añadir al carrito',
    paymentMethod: 'Método de pago',
    history: 'Historial',
    currentOrder: 'Pedido actual',
    logOut: 'Salir',
    pay: 'Pagar',
    saveAsADraft: 'Guardar como borrador',
    deleteOrder: 'Borrar pedido',
    order: 'Pedido',
    paymentConfirmation: 'Confirmación del pago',
    cancel: 'Cancelar',
    markAsPaid: 'Pagado',
    theTotalIs: 'El total es',
    cashPaymentConfirmation: 'Puedes usar el campo de abajo para calcular el cambio. Recuerda marcar el pedido como pagado cuando hayas terminado.',
    "wristband-rfidPaymentConfirmation": 'Dile al cliente que acerque su pulsera al sensor.',
    "credit-cardPaymentConfirmation": 'Por favor, continua con tu TPV y marca el pedido como pagado cuando hayas terminado.',
    change: 'Cambio',
    eg: 'Ex',
    paidWith: 'Pagado con',
    selectAPaymentMethod: 'Por favor, selecciona un método de pago',
    somethingWentWrong: 'Parece que ha habido algún error',
    markedAsPaid: '¡Pedido marcado como pagado!',
    "applyADiscount?": '¿Aplicar un descuento?',
    discount: 'Descuento',
    free: 'Gratis',
    draftOrders: 'Pedidos pendientes',
    loadedOrder: 'Pedido cargado',
    in_progress: 'Borrador',
    processing: 'Procesando',
    on_going: 'En curso',
    completed: 'Completado',
    succeeded: 'Recibido',
    invalid: 'Inválido',
    refunded: 'Devuelto',
    transferred: 'Transferido',
    collapse: 'Ocultar',
    close: 'Cerrar',
    buy: 'Comprar',
    eventNotFound: 'Evento no encontrado',
    cartIsEmpty: 'El carrito está vacio.\n¡Tómate algo 🍸!',
    minimumOrderIs: 'El pedido mínimo es de {{totalPrice}}',
    'dontWannaMove?': '¿No quieres moverte?',
    deliverToMyPlace: 'Recíbelo en tu sitio',
    addDelivery: 'Recibir en mi sitio',
    addDeliveryExplanation: 'Por favor, indícanos dónde quieres recibir tu pedido. Necesitamos poder localizarte.',
    seating: 'Asiento',
    eg: 'ex',
    deliverTo: 'Recibir en',
    removeDelivery: 'Eliminar entrega',
    removeDeliveryExplanation: '¿Eliminar la entrega en {{delivery}}?',
    remove: 'Eliminar',
    deliveryModalTitle: '¿Quieres recibir el pedido en tu sitio?',
    modify: 'Modificar',
    welcomeBack: '¡Hola de nuevo!',
    activeOrders: 'Pedidos activos',
    pastOrders: 'Pedidos pasados',
    profileDrawerSignInCopy: "¿Aún no tienes una cuenta? ¡Accede y obtén tu pedido aún más rápido!",
    product: 'producto',
    products: 'productos',
    soldOut: 'Agotado',
    signIn: 'Acceder',
    bringItToVipZone: 'Entregarlo en la zona VIP',
    somethingOutOfStock: "No hay stock de algo en el pedido",
    salesAreNotAvailable: 'Las ventas están desactivadas',
    from: 'Desde',
    selectOneOption: 'Por favor, selecciona una opción',
    glassModalTitle: '¿Quieres vasos reutilizables?',
    addGlassExplanation: 'Recuerda que para recibir tu bebida necesitas un vaso reutilizable',
    glass: 'vaso',
    glasses: 'vasos',
    continue: 'Continuar',
    continueWithoutGlasses: 'Continuar sin vasos',
    dontShowAgain: 'No volver a mostrar',
    notice: 'Aviso',
    bannedAlcohol: 'Prohibida la venta de bebidas alcohólicas a menores de 18 años.',
    myOrders: 'Mis pedidos'
}

const promotions = {
    allVenues: 'Cualquier local',
    spending: 'Al gastar',
    usesLeft: 'Quedan {{uses}}',
    promotions: 'Promociones',
    promo: 'Promo',
    discountOff: '{{discount}} menos',
    couponAvailable: 'Cupón disponible',
    'haveACode?': '¿Tienes un código?',
    'haveADiscount?': '¿Tienes un descuento?',
    addDiscount: 'Añadir descuento',
    addItHere: 'Añádelo aquí',
    discountCode: 'Código descuento',
    send: 'Enviar',
    invalidCode: 'Código inválido',
    promotionAdded: 'Promoción añadida',
    applyingPromotions: 'Aplicando',
    andNMore: 'y {{n}} más'
}

const dates = {
    "today": "Hoy",
    "yesterday": "Ayer",
    "tomorrow": "Mañana",
    "twoDaysAgo": "Hace dos días",
    "monday": "lunes",
    "tuesday": "martes",
    "wednesday": "miércoles",
    "thursday": "jueves",
    "friday": "viernes",
    "saturday": "sábado",
    "sunday": "domingo",
    "theDay": "El {{day}}",
    "thePastDay": "El {{day}} pasado",
    "theFutureDay": "El próximo {{day}}",
    "midString": "El {{weekday}} {{date}} de {{month}}",
    "january": "enero",
    "february": "febrero",
    "march": "marzo",
    "april": "abril",
    "may": "mayo",
    "june": "junio",
    "july": "julio",
    "august": "agosto",
    "september": "septiembre",
    "october": "octubre",
    "november": "noviembre",
    "december": "diciembre",
    "momentAgo": "hace un momento",
    "weekAbbreviation": "sem",
    "year": "año",
    "years": "años",
    "longDate": "{{date}} de {{month}} de {{fullYear}}",
    "sundayAbbreviation": "Dom",
    "mondayAbbreviation": "Lun",
    "tuesdayAbbreviation": "Mar",
    "wednesdayAbbreviation": "Mié",
    "thursdayAbbreviation": "Jue",
    "fridayAbbreviation": "Vie",
    "saturdayAbbreviation": "Sab",
    "mondayLetter": "L",
    "tuesdayLetter": "M",
    "wednesdayLetter": "X",
    "thursdayLetter": "J",
    "fridayLetter": "V",
    "saturdayLetter": "S",
    "sundayLetter": "D",
}

const spanishTranslateJSON = { 
    ...manualOrders,
    ...promotions,
    ...dates
};
export default spanishTranslateJSON;